import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks/useSelector";
import { ROLES, VIEWER_ROLES } from "../../constants/textconstants";
import { useSelector } from "react-redux";

const Tabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const userData = useSelector((state: any) => state.formConfig.user);

  let tabs = [];


  if (userData.role?.toLowerCase() === ROLES.ISSUER.toLowerCase()) {
    tabs = [
      { name: "Overview", path: "/" },
      { name: "Certificate Requests", path: "/all-requests/0" },
    ];
  } else if (userData.role?.toLowerCase() === ROLES.APPROVER.toLowerCase()) {
    tabs = [
      { name: "Overview", path: "/" },
      { name: "Certificate Requests", path: "/all-requests/0" },
      { name: "Assigned Booklets", path: "/assigned-certificates" }
    ]
  }
  else if(Object.values(VIEWER_ROLES).map(r => r.toLowerCase()).includes(userData.role?.toLowerCase())){
     tabs = [
      { name: "Overview", path: "/" },
      { name: "Issued Certificates", path: "/issued-certificates" },
    ]
  }
  else {
    tabs = [
      { name: "Overview", path: "/" },
      { name: "Issued Certificates", path: "/issued-certificates" },
      { name: "Assigned Booklets", path: "/assigned-certificates" },
      // { name: "Manage Users", path: "/manage-users" },
    ]
  }

  

  return (
    <div className="tabs">
      {tabs.map((tab) => {
        let isActive = false;
        if (tab.name === "Certificate Requests") {
          isActive = location.pathname.startsWith("/all-requests") || location.pathname.startsWith("/review-request");
        } else if (tab.name === "Issued Certificates") {
          isActive = location.pathname.startsWith("/issued-certificates") || location.pathname.startsWith("/review-request");
        } else if (tab.name === "Assigned Booklets") {
          isActive = location.pathname.startsWith("/assigned-certificates");
        }
        else {
          isActive = location.pathname === tab.path;
        }

        let activeclass = isActive ? "active" : "";
        return(
        <span
          key={tab.name}
          className={tab.name === 'Overview' ? `certificate-overview-container ${activeclass}`:
          tab.name =='Issued Certificates'? `issued-certificate-container ${activeclass}`:
          tab.name == 'Assigned Booklets'? `assigned-booklets-container ${activeclass}`:  activeclass}
          onClick={() => navigate(tab.path)}
        >
          {tab.name}
        </span>
      )
      }
    )}
    </div>
  );
};

export default Tabs;
